import React from "react";
import { withRouter } from "react-router-dom";
import AssetDetails from "../../widgets/office/asset/AssetDetails";
import GrossLeasingTrendGraph from "../../widgets/office/asset/GrossLeasingTrendGraph";
import TopTenActiveTenantsAsset from "../../widgets/office/asset/TopTenActiveTenantsAsset";
import RentalTrendPassingFitoutGraph from "../../widgets/office/asset/RentalTrendPassingFitoutGraph";
import LeaseExpiryFutureRentals from "../../widgets/office/asset/LeaseExpiryFutureRentals";
import SectorBreakupActiveTenants from "../../widgets/office/asset/SectorBreakupActiveTenants";
import AbsorbtionTrends from "../../widgets/office/asset/AbsorbtionTrends";
import RecentTransactionsAsset from "../../widgets/office/asset/RecentTransactionsAsset";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import RentBySectors from "../../widgets/office/asset/RentBySectors";
import LeaseExpiry from "../../widgets/office/asset/LeaseExpiry";
import AssetVsMicromarketRent from "../../widgets/office/asset/AssetVsMicromarketRent";
import Transactionsize from "../../widgets/office/asset/Transactionsize";
import AssetvsMicromarketWale from "../../widgets/office/asset/AssetvsMicromarketWale";
import AssetMarketAnalysis from "../../widgets/office/asset/AssetMarketAnalysis";
import BenchmarkProjects from "../../widgets/office/asset/BenchmarkProjects";
import LatestSupply from "../../widgets/office/asset/LatestSupply";
import UpcomingSupply from "../../widgets/office/asset/UpcomingSupply";
import MarketRentVsPassingRent from "../../widgets/office/asset/MarketRentVsPassingRent";
import MajorRecentSaleTransactions from "../../widgets/office/dashboard/MajorRecentSaleTransactions";
import KeyProjects from "../../widgets/office/asset/KeyProjects";
import { connect } from "react-redux";
import FilterContext from "../../routes/FilterContext";
import RecentNews from "../../widgets/office/asset/RecentNews";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import BuildingDetails from "../../widgets/office/asset/BuildingDetails";
function mapStateToProps(state) {
  return {
    filters: state.selectedFilters,
    downloadOption: state.downloadOptions,
    creUser: state.creUser,
  };
}
class Asset2 extends React.Component {
  static contextType = FilterContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
  }
  render() {
    return (
      <div className="container-fluid developer mapsPage customPage">
        <div className="row mb-4">
          <div className="col-lg-12 mb-4">
            <AssetDetails />
          </div>
          <div className="mapsTab">
            <Tabs>
              <TabList>
                <Tab>Demand</Tab>
                <Tab>Rentals </Tab>
                <Tab>Transactions </Tab>
                <Tab>Charts </Tab>
              </TabList>
              <TabPanel>
                <div className="row mb-4">
                  <div className="col-lg-8 mb-4">
                    <GrossLeasingTrendGraph />
                  </div>
                  <div className="col-lg-4 mb-4">
                    <TopTenActiveTenantsAsset />
                  </div>
                  {/* <div className="col-lg-6 mb-4">
                    <AbsorbtionTrends />
                  </div> */}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <AssetMarketAnalysis />
                    </div>
                  )}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <KeyProjects />
                    </div>
                  )}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <BenchmarkProjects />
                    </div>
                  )}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <LatestSupply />
                    </div>
                  )}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <UpcomingSupply />
                    </div>
                  )}
                  {this.props.creUser === 1 && (
                    <div className="col-lg-12 mb-4">
                      <MarketRentVsPassingRent />
                    </div>
                  )}
                  <div className="col-lg-12 mt-4">
                    <RecentNews />
                  </div>
                  <div className="col-lg-12 mt-4">
                    <BuildingDetails />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row mb-4">
                  <div className="col-lg-6 mb-4">
                    <RentalTrendPassingFitoutGraph />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <LeaseExpiryFutureRentals />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <RentBySectors />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <AssetVsMicromarketRent />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row mb-4">
                  <div className="col-lg-12 my-4">
                    <RecentTransactionsAsset />
                  </div>
                  <div className="col-lg-12">
                    <MajorRecentSaleTransactions />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row mb-4">
                  <div className="col-lg-6 mb-4">
                    <LeaseExpiry />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <SectorBreakupActiveTenants />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <Transactionsize />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <AssetvsMicromarketWale />
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Asset2);
